(() => {
  if (window.sgdStoriesBound) return;
  window.sgdStoriesBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-story-direction]');
    if (!button) return;
    const track = button.closest('.sgd-stories').querySelector('.sgd-stories__track');
    const card = track.querySelector('.sgd-stories__card');
    if (!card) return;
    track.scrollBy({left: Number(button.dataset.storyDirection) * (card.getBoundingClientRect().width + 24), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest('.sgd-stories__card');
    if (!card) return;
    const track = card.closest('.sgd-stories__track');
    track.scrollBy({left: card.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: 'auto'});
  });
})();
